import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PersonAdd } from '@material-ui/icons';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import { CONSTANTS } from '../../../../../constants/constants';

const useStyles = makeStyles((theme) => ({
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    }
  },
  red: {
    backgroundColor: '#B00020'
  },
  green: {
    backgroundColor: '#0DC599'
  } }));

const IdentityItem = ({ markAsRead, notif, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const currentUser = data.user;
  const currentStatus = data.step ? data.step.status : undefined;

  return (
    <ListItem
      alignItems='flex-start'
      onClick={markAsRead.bind(null, notif.id)}
      key={notif.id}
      divider
      className={classes.listItem}
    >
      {currentStatus === CONSTANTS.STEP.STATUS.SIGNED &&
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <PersonAdd />
        </Avatar>
      </ListItemAvatar>
      }

      <ListItemText
        primary={t(`notification:${notif.type}:name:${currentStatus}`)}
        secondary={
          <React.Fragment>
            <Typography
              component='span'
              color='textSecondary'
              title={t(`notification:${notif.type}:description:${currentStatus}`, { elementName: currentUser.userId })}
            >
              {t(`notification:${notif.type}:description:${currentStatus}`, { elementName: currentUser.userId })}
            </Typography>
            <br />
            <Moment
              format='DD/MM/YYYY HH:mm:ss'
              style={{ fontSize: '0.8em' }}
            >
              {notif.createdAt}
            </Moment>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

IdentityItem.propTypes = {
  markAsRead: PropTypes.func,
  notif: PropTypes.object,
  data: PropTypes.object
};

export default IdentityItem;
